import { IsBoolean, IsDefined } from 'class-validator';

export class PositionAnchorsStateDto {
  @IsDefined()
  @IsBoolean()
  enableTop!: boolean;

  @IsDefined()
  @IsBoolean()
  enableRight!: boolean;

  @IsDefined()
  @IsBoolean()
  enableBottom!: boolean;

  @IsDefined()
  @IsBoolean()
  enableLeft!: boolean;

  @IsDefined()
  @IsBoolean()
  enabled!: boolean;
}
